import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminApi, errText } from "@/lib/api";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import { ImageManager } from "@/pages/admin/ImageManager";
import { Button } from "@/components/ui/button";

export default function AdminHome() {
  const [images, setImages] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    adminApi.get("/admin/home").then((r) => setImages(Array.isArray(r.data?.images) ? r.data.images : []));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await adminApi.put("/admin/home", {
        images: images.map(({ media_id, alt, width, height, animated }) => ({ media_id, alt, width, height, animated })),
      });
      toast.success("Home page updated");
    } catch (ex) {
      toast.error(errText(ex));
    } finally {
      setSaving(false);
    }
  };

  return (
    <AdminLayout
      title="Home page photos"
      back="/admin"
      actions={<Button className="rounded-full" onClick={save} disabled={saving || !images} data-testid="save-home-button">{saving ? "Saving…" : "Save"}</Button>}
    >
      <section className="bg-white rounded-2xl p-5 sm:p-6">
        <p className="text-sm text-neutral-600 mb-4">These are the vertical strips on the front page, left to right (top to bottom on phones).</p>
        {images && <ImageManager images={images} onChange={setImages} uploadPath="/admin/upload" max={5} />}
      </section>
    </AdminLayout>
  );
}
